import { MutationTree } from 'vuex';
import { NodeAutoLoginDefinitionState } from './types';
import { AutoLoginAppItem } from '../../auto_login_app/types';
import * as types from './mutation-types';

export const mutations: MutationTree<NodeAutoLoginDefinitionState> = {
    // ノード自動ログイン定義一覧系
    [types.SEARCH_START](state) {
        const searchState = state.search;
        searchState.error = false;
        searchState.errorCode = undefined;
        searchState.errorMsg = undefined;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; auto_login_definitions: Array<AutoLoginAppItem> }) {
        state.autoLoginDefinitionCount = payload.count;
        state.autoLoginDefinitions = payload.auto_login_definitions;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        state.autoLoginDefinitions = undefined;
        state.autoLoginDefinitionCount = 0;

        state.search.isProcessing = false;
        state.search.isFetchSuccess = false;
        state.search.error = false;
        state.search.errorCode = undefined;
        state.search.errorMsg = undefined;
    },
};
